import React, { PureComponent } from 'react';
import DarkModeToggle from "react-dark-mode-toggle";
import { Link as ScrollLink } from "react-scroll";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { SiBuymeacoffee } from "react-icons/si";

class Navbar extends PureComponent {

    handleDarkModeToggle = (isChecked, event) => {
        //event.preventDefault();

        this.props.onUpdate(isChecked);
    };

    render() {
        return (
            <header className="bg-sky-100 dark:bg-gray-800 md:sticky top-0 z-50">
                <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
                    <ScrollLink
                        to="about"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={750}
                        className="link title-font font-medium dark:text-white mb-4 md:mb-0 text-xl cursor-pointer hover:text-gray-700 dark:hover:text-gray-300"
                        activeClass="active"
                    >
                        Brandon Clark
                    </ScrollLink>
                    <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:dark:border-gray-700	flex flex-wrap items-center text-base">
                        <ScrollLink
                            to="projects"
                            spy={true}
                            smooth={true}
                            offset={-70}
                            duration={750}
                            className="mr-2 hover:dark:text-white cursor-pointer"
                        >
                            Projects
                        </ScrollLink>
                        <ScrollLink
                            to="skills"
                            spy={true}
                            smooth={true}
                            offset={-70}
                            duration={750}
                            className="ml-2 mr-2 hover:dark:text-white cursor-pointer"
                        >
                            Skills
                        </ScrollLink>
                        <ScrollLink
                            to="testimonials"
                            spy={true}
                            smooth={true}
                            offset={-70}
                            duration={750}
                            className="ml-2 hover:dark:text-white cursor-pointer"
                        >
                            Testimonials
                        </ScrollLink>
                    </nav>
                    <ScrollLink
                        to="contact"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={750}
                        className="inline-flex items-center cursor-pointer dark:bg-gray-800 border-0 py-1 px-2 focus:outline-none hover:dark:bg-gray-700 rounded text-base mt-2 md:mt-0 md:mr-2"
                    >
                        Contact Me
                    </ScrollLink>

                    <div className="flex items-center md:mt-0 md:mb-0 mt-2 mb-2">
                        <a
                            href="https://github.com/bclarksoftware"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-gray-900 dark:text-white hover:text-gray-600 dark:hover:text-gray-300 mx-1"
                            aria-label="GitHub"
                        >
                            <FaGithub className="w-6 h-6" />
                        </a>
                        <a
                            href="https://www.linkedin.com/in/bclark16/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-400 dark:text-white hover:text-gray-600 dark:hover:text-gray-300 mx-1"
                            aria-label="LinkedIn"
                        >
                            <FaLinkedin className="w-6 h-6" />
                        </a>
                        <a
                            href="https://buymeacoffee.com/bclarksoftware"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-amber-500 dark:text-amber-400 hover:text-amber-600 dark:hover:text-amber-300 mx-1"
                            aria-label="Buy Me a Coffee"
                        >
                            <SiBuymeacoffee className="w-6 h-6" />
                        </a>
                    </div>

                    <DarkModeToggle
                        onChange={this.handleDarkModeToggle}
                        checked={this.props.isDarkMode}
                        size={50}
                        className="ml-4 mr-4"
                    />
                </div>
            </header>
        );
    }
}

export default Navbar;